import { render } from "./AddNotesComponent.vue?vue&type=template&id=258ab437&scoped=true&ts=true"
import script from "./AddNotesComponent.vue?vue&type=script&lang=ts"
export * from "./AddNotesComponent.vue?vue&type=script&lang=ts"

import "./AddNotesComponent.vue?vue&type=style&index=0&id=258ab437&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258ab437"]])

export default __exports__